import { QueryClient } from "@tanstack/react-query";

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      retry: (failureCount, error) => {
        // Don't retry on 429 rate limit errors
        if (error?.response?.status === 429) {
          console.log('Rate limit detected, not retrying');
          return false;
        }
        // Only retry network errors, max 2 times
        return failureCount < 2 && (!error.response || error.code === 'ERR_NETWORK');
      },
      retryDelay: (attemptIndex) => {
        // Exponential backoff: 1s, 2s, 4s
        return Math.min(1000 * Math.pow(2, attemptIndex), 30000);
      },
      staleTime: 5 * 60 * 1000, // 5 minutes
      cacheTime: 10 * 60 * 1000, // 10 minutes
    },
  },
});